export const toCheckboxOption = <T, K extends keyof T>(arr: T[], options: { value: K; label: K }) =>
  arr.map(obj => ({
    label: obj[options.label],
    value: obj[options.value],
  }));
